module.exports = __webpack_public_path__ + "static/testimonial-6-e7e97fbc1618cd1b348ad1f67dee6817.png";